import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppStore from '../../store/AppStore'
import { connect } from 'react-redux'
import DtoCity from '../../referential/dto/DtoCity'
import { getResult } from '../../utils/FilterUtils'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import { isEqual, uniqWith } from 'lodash'
import { substringText } from '../../utils/StringUtils'
import UUID from 'uuid'
import Tooltip from '@material-ui/core/Tooltip'
import { Icon } from '@material-ui/core'
import { css } from 'glamor'
import i18n from 'simple-react-i18n'

class AutocompleteList extends Component {

	constructor(props) {
		super(props)
		this.state = { filterLength: 20 }
	}

	select = value => () => {
		const assignValue = Object.assign({}, value, {
			type: this.props.type
		})
		const tmp = this.props.selectedFilters.slice()
		tmp.push(assignValue)
		const resultToAdd = uniqWith(tmp, isEqual)
		$('.tooltipped_research').tooltip('remove')
		AppStore.dispatch(AdministrationAction.selectedFilters(resultToAdd))
		this.props.removeEntry()
	}

	getMoreBtn = () => {
		const color = '#161832'
		if (this.props.list.length > this.state.filterLength) {
			return (
				<div className='collection-more'>
					<Tooltip title={i18n.displayMore}>
						<Icon className='material-icons' {...css({
							width: 36,
							height: 36,
							color: color,
							fontSize: '2rem !important',
							margin: '7px !important'
						})} onClick={() => this.increaseFilterLength()}> add </Icon>
					</Tooltip>
					<span onClick={() => this.increaseFilterLength()}>{i18n.display} {this.increaseLength()} {i18n.more}</span>
				</div>)
		}
		return (null)
	}

	getData = (listSelected) => {
		const result = listSelected.map(o => {
			const className = (() => {
				const resultClass = 'row no-margin collection-item tooltipped_research'
				if (this.props.isResearchMap) {
					return resultClass + ' autocomplete-item-dark'
				}
				return resultClass + ' autocomplete-item'
			})()
			const label = (() => {
				if (this.props.isResearchMap) {
					return substringText(o.label, 35)
				}
				return substringText(o.label)
			})()
			return (
				<div key={ UUID.v4() } data-position='top' data-delay='20' data-tooltip={ o.label }
					className={ className }
					onClick={ this.select(o) } style={ { borderBottom: '0px', fontSize: '12px' } }>
					{ label }
				</div>
			)
		})
		const title = listSelected.length === 0 || listSelected.length === 1 ? this.props.singularTitle : this.props.plurialTitle
		return (
			<div className='collection with-header' style={ { borderRadius: '0px' } }>
				<div className='collection-header no-margin filter-header'>
					<div className='valign-wrapper'>
						<i className='material-icons margin-right-10'>{ this.props.icon }</i>
						<b className='font-size-15'>{ title } ( { this.props.list.length } )</b>
					</div>
				</div>
				<div className='collection-list'>
					{ result }
				</div>
				{ this.getMoreBtn() }
			</div>
		)
	}

	render() {
		const listSelected = getResult(this.props.list, this.state.filterLength)
		if (listSelected.length) {
			return (
				<div className='col s3 no-padding no-margin' style={ { minWidth: '277px' } }>
					<div className='row no-margin autocomplete-list'>
						<div className='col s12 no-padding'>
							{ this.getData(listSelected) }
						</div>
					</div>
				</div>
			)
		}
		return (null)
	}

	componentWillUpdate() {
		$('.tooltipped_research').tooltip('remove')
	}

	componentWillUnmount() {
		$('.tooltipped_research').tooltip('remove')
	}

	componentDidUpdate() {
		$('.tooltipped_research').tooltip({ delay: 20 })
	}

	componentDidMount() {
		$('.tooltipped_research').tooltip({ delay: 20 })
	}

	increaseFilterLength() {
		const filterLength = this.state.filterLength + Math.min(20, Math.max(0, (this.props.list.length - this.state.filterLength)))
		this.setState({ filterLength: filterLength })
	}
	increaseLength() {
		return Math.min(20, Math.max(0, (this.props.list.length - this.state.filterLength)))
	}
}

AutocompleteList.propTypes = {
	list: PropTypes.arrayOf(PropTypes.instanceOf(DtoCity)).isRequired,
	type: PropTypes.object.isRequired,
	selectedFilters: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.object
	})),
	isResearchMap: PropTypes.string,
	icon: PropTypes.string,
	isFirst: PropTypes.boolean,
	isMiddle: PropTypes.boolean,
	isEnd: PropTypes.boolean,
	singularTitle: PropTypes.string,
	plurialTitle: PropTypes.string,
	removeEntry: PropTypes.func
}

AutocompleteList.defaultProps = {
	list: [],
	title: '',
	isFirst: false,
	isMiddle: false,
	isEnd: false
}
const mapStateToProps = store => {
	return {
		selectedFilters: store.AdministrationReducer.selectedFilters
	}
}
export default connect(mapStateToProps)(AutocompleteList)



// WEBPACK FOOTER //
// ./src/components/autocompleteChips/AutocompleteList.js